import { Empty, Table } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomTable = ({ ...props }) => {
  const { i18n } = useTranslation('');

  const language = i18n.languages?.length ? i18n.languages[0] : 'en';
  const currentLang = ['en', 'sw'].includes(language) ? language : 'en';

  const tableLocale = currentLang === 'sw'
    ? {
        triggerDesc: 'Klicka för fallande sortering',
        triggerAsc: 'Klicka för stigande sortering',
        cancelSort: 'Avbryt sortering',
        emptyText: (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ingen data" />
        ),
      }
    : {};

  return <Table locale={tableLocale} {...props} />;
};

export default CustomTable;
CustomTable.propTypes ={
  props: PropTypes.object
};

